import {
  imgFactionArmyHeader,
  imgFactionHospitalExperience,
  imgFactionHospitalHeader,
  imgFactionMedsiExperience,
  imgFactionMedsiHeader,
  imgFactionRegion24Experience,
  imgFactionRegion24Header,
} from "@/shared/assets/img";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";

export const factionsList = {
  [FactionEnum.RUSSIANARMY]: {
    src: "/svg/faction/logo/army.svg",
    headerSrc: imgFactionArmyHeader,
    experienceSrc: "./svg/faction/army_experience.svg",
    dataMzAccent: "olive",
    gradient: "bg-gradient-olive",
    color: "#405C4A",
    colorAccent: "#70C299",
    colorGradient1: "#5F816C",
    colorGradient2: "#4B6C58",
  },
  [FactionEnum.HOSPITAL]: {
    src: "/svg/faction/logo/hospital.svg",
    headerSrc: imgFactionHospitalHeader,
    experienceSrc: imgFactionHospitalExperience,
    dataMzAccent: "accent",
    gradient: "bg-gradient-accent",
    color: "#DB383A",
    colorAccent: "#FF4D4D",
    colorGradient1: "#E53F3F",
    colorGradient2: "#AB2929",
  },
  [FactionEnum.MEDSI]: {
    src: "/svg/faction/logo/medsi.svg",
    headerSrc: imgFactionMedsiHeader,
    experienceSrc: imgFactionMedsiExperience,
    dataMzAccent: "lightBlue",
    gradient: "bg-gradient-lightBlue",
    color: "#022840",
    colorAccent: "#1892DC",
    colorGradient1: "#007FDB",
    colorGradient2: "#0164AC",
  },
  [FactionEnum.REGION24]: {
    src: "/svg/faction/logo/region24.svg",
    headerSrc: imgFactionRegion24Header,
    experienceSrc: imgFactionRegion24Experience,
    dataMzAccent: "lightBlue",
    gradient: "bg-gradient-lightBlue",
    color: "#022840",
    colorAccent: "#1892DC",
    colorGradient1: "#007FDB",
    colorGradient2: "#0164AC",
  },
};
